<template>

    <div class="fonts-wrapper"  :class="{ active : activeOverlay}">
        <span class="caption ft-xbld">{{ caption }}</span>
        <div class="fonts-outer" ref="outer">
            <div class="dft-preview" @click.prevent="toggleFonts">
                <span class="txt" :class="Global.mockupConfig.activeFont">{{ currentFont }}</span>
                <span class="arw"></span>
            </div>
            <div class="expand-outer" v-show="activeOverlay">
                <div class="bg"></div>
                <div class="in">
                    <div class="line ft-bld" @click.prevent="fontSelection('Inter','inter')" :class="{ active : currentFont === 'Inter' }">
                        <span class="name">Inter</span>
                        <span class="prev">Abc</span>
                    </div>
                    <div class="line" v-for="font, index in fonts" :key="index" :class="[font.className, { active : currentFont === font.caption }]" @click.prevent="fontSelection(font.caption,font.className)">
                        <span class="name">{{ font.caption }}</span>
                        <span class="prev">Abc</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import Global from '../lib/GlobalState'

    export default {

        name: 'FontsWrapper',

        props: {
            caption: String,
            fonts: Array
        },

        data() {
            return {
                Global,
                currentFont: 'Inter',
                activeOverlay: false
            }
        },

        mounted() {
            document.body.addEventListener('click', this.bodyClick)
        },

        methods: {

            toggleFonts() {
                this.activeOverlay = !this.activeOverlay
            },

            fontSelection(caption,classname) {
                if (this.currentFont == caption) return
                this.currentFont = caption
                this.Global.mockupConfig.activeFont = classname
                this.$parent.$emit("newFont")
            },

            bodyClick(event) {
                if (!this.activeOverlay) return
                let el = '.' + this.$refs.outer.classList[0] + ' *'
                if (!event.target.matches(el))
                    this.activeOverlay = false
            },

        }


    }

</script>